import { render } from "./SavedMessage.vue?vue&type=template&id=1a7f26dc"
const script = {}
script.render = render

export default script